module.exports = __webpack_public_path__ + "img/scene1-3.49bee20d.jpg";